import React from 'react';

export const AnimatedLogo = ({ size = 48, className = '' }) => {
  return (
    <div 
      className={`animated-logo-container ${className}`} 
      style={{ width: size, height: size }}
    >
      <img 
        src="/logo.png" 
        alt="Hippocrate MG" 
        className="animated-logo-image"
        style={{ width: size, height: size }}
      />
      
      {/* Glow pulse ring */}
      <div className="glow-ring" />
      <div className="glow-ring glow-ring-delayed" />

      <style>{`
        .animated-logo-container {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          overflow: visible;
        }
        
        .animated-logo-image {
          object-fit: contain;
          border-radius: 10px;
          filter: 
            grayscale(100%) 
            brightness(1.3) 
            contrast(1.1)
            drop-shadow(0 0 8px rgba(192, 192, 192, 0.4));
          animation: pulse-glow 2.5s ease-in-out infinite;
          position: relative;
          z-index: 2;
        }
        
        .glow-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(192, 192, 192, 0.3);
          border-radius: 12px;
          transform: translate(-50%, -50%);
          animation: ring-pulse 2.5s ease-out infinite;
          z-index: 1;
          pointer-events: none;
        }
        
        .glow-ring-delayed {
          animation-delay: 1.25s;
        }
        
        @keyframes pulse-glow {
          0%, 100% { 
            filter: 
              grayscale(100%) 
              brightness(1.2) 
              contrast(1.1)
              drop-shadow(0 0 6px rgba(192, 192, 192, 0.3));
          }
          50% { 
            filter: 
              grayscale(100%) 
              brightness(1.5) 
              contrast(1.15)
              drop-shadow(0 0 15px rgba(220, 220, 220, 0.6));
          }
        }
        
        @keyframes ring-pulse {
          0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0.6;
            border-color: rgba(192, 192, 192, 0.4);
          }
          100% {
            transform: translate(-50%, -50%) scale(1.4);
            opacity: 0;
            border-color: rgba(192, 192, 192, 0);
          }
        }
        
        .animated-logo-container:hover .animated-logo-image {
          filter: 
            grayscale(100%) 
            brightness(1.6) 
            contrast(1.2)
            drop-shadow(0 0 20px rgba(220, 220, 220, 0.7));
        }
      `}</style>
    </div>
  );
};

export default AnimatedLogo;
